import React from 'react';
import { Card, CardContent } from '../components/ui/card';

const AchievementsSection = ({ t }) => {
  const achievements = [
    {
      title: t.achievement_bar_council || 'Bar Council Felicitation',
      description: t.achievement_bar_council_desc || 'Felicitation of Mr. Shiv Kishore Gaur on being elected President, Bar Council – Uttar Pradesh',
      image: 'https://customer-assets.emergentagent.com/job_highcourt-law/artifacts/9p82645i_1000771258.jpg'
    },
    {
      title: t.achievement_dm || 'District Magistrate Honor',
      description: t.achievement_dm_desc || 'Felicitation of Mr. Sanjeev Ranjan on assuming charge as District Magistrate, Aligarh',
      image: 'https://customer-assets.emergentagent.com/job_highcourt-law/artifacts/8wixv1yq_1000771260.jpg'
    },
    {
      title: t.achievement_sir_syed || 'Legal Awareness Contribution',
      description: t.achievement_sir_syed_desc || 'Felicitation by Sir Syed Classes for contribution to legal awareness and youth motivation',
      image: 'https://customer-assets.emergentagent.com/job_highcourt-law/artifacts/22tdqfph_1000771262.jpg'
    },
    {
      title: t.achievement_community || 'Community Service & Youth Engagement',
      description: t.achievement_community_desc || 'Active participation in community legal awareness programs and youth motivation initiatives',
      image: 'https://customer-assets.emergentagent.com/job_highcourt-law/artifacts/01rrkyni_1000771255.jpg'
    }
  ];

  return (
    <section id="achievements" className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-4 text-gray-900" style={{ fontFamily: 'Crimson Text, serif' }}>
          {t.achievements_title || 'Recognition & Achievements'}
        </h2>
        <p className="text-center text-gray-600 mb-12">
          {t.achievements_subtitle || 'Honored for contributions to legal profession and society'}
        </p>
        
        <div className="grid md:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {achievements.map((achievement, idx) => (
            <Card key={idx} className="overflow-hidden hover:shadow-lg transition-shadow">
              <div className="aspect-video overflow-hidden">
                <img 
                  src={achievement.image} 
                  alt={achievement.title} 
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                />
              </div>
              <CardContent className="pt-6">
                <h3 className="text-xl font-bold mb-2 text-gray-900">{achievement.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">{achievement.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AchievementsSection;
